const state = {
  // Todo show filter (used to show "save filter" button, should be a computed return true/false derived from the active filter value
  showEnFilter: false,
  saveEnFilter: [],
  listeEntreprises: [],
  listeEntreprisesPagination: {
    total: 0,
    per_page: 10,
    current_page: 1,
    last_page: 1,
    next_page_url: '',
    prev_page_url: '',
    from: 0,
    to: 0
  },
  checkedEnFilters: [],
  activeEnFilter: {
    searchText: null,
    searchStatut: [],
    searchCodeActivite: [],
    searchTypeActivite: [],
    searchchiffreAffaire: ['0K', '+100M'],
    searchCapitalSocial: ['0K', '+100M'],
    searchFormeJuridique: [],
    searchEtat: [],
    searchType: [],
    searchWilaya: [],
    searchNationalite: [],
    // searchAnnonceur: [],
    searchSecteur: []
    /* dateEcheance: {
      type: null,
      start: null,
      end: null
    } */
  },
  searchEnFilter: {
    searchText: null,
    searchStatut: [],
    searchCodeActivite: [],
    searchTypeActivite: [],
    searchchiffreAffaire: ['0K', '+100M'],
    searchCapitalSocial: ['0K', '+100M'],
    searchFormeJuridique: [],
    searchEtat: [],
    searchType: [],
    searchWilaya: [],
    searchNationalite: [],
    // searchAnnonceur: [],
    searchSecteur: []
    /* dateEcheance: {
      type: null,
      start: null,
      end: null
    } */
  },
  addButtonEnFilter: false,
  chargementTableEntreprise: false,
  initRecherche: false
}

const mutations = {
  SET_LOAD_TABLE_ENTREPRISE: (state, filter) => {
    state.chargementTableEntreprise = filter
  },
  SET_EN_FILTER: (state, filter) => {
    state.showEnFilter = filter
  },
  SET_SAVE_EN_FILTER: (state, filter) => {
    state.saveEnFilter.push(filter)
  },
  SET_DELETE_EN_FILTER: (state, filter) => {
    state.saveEnFilter = filter
  },
  SET_UPDATE_CHECKED_EN_FILTER: (state, filter) => {
    state.checkedEnFilters = filter
  },
  SET_DELETE_CHECKED_EN_FILTER: (state, filter) => {
    state.checkedEnFilters = []
  },
  SET_BUTTON_EN_FILTER: (state, value) => {
    state.addButtonEnFilter = value
  },
  UNCHECK_ALL_EN_FILTERS: (state) => {
    state.saveEnFilter.filter((filter) => filter.checked === true).forEach((filter) => {
      filter.checked = false
    })
  },
  CHECK_UNCHECK_EN_FILTER: (state, filter) => {
    console.log(filter)
    if (!filter.checked) {
      state.saveEnFilter.filter((filter) => filter.checked === true).forEach((filter) => {
        filter.checked = false
      })
      state.searchEnFilter = JSON.parse(JSON.stringify(Object.assign(state.searchEnFilter, filter)))
      // state.activeFilter = JSON.parse(JSON.stringify(Object.assign(state.searchFilter, filter)))
      delete state.searchEnFilter.nom
      delete state.searchEnFilter.checked
      delete state.searchEnFilter.id
    } else {
      state.searchEnFilter = JSON.parse(JSON.stringify(Object.assign(state.searchEnFilter, {
        searchText: null,
        searchStatut: [],
        searchCodeActivite: [],
        searchTypeActivite: [],
        searchchiffreAffaire: ['0K', '+100M'],
        searchCapitalSocial: ['0K', '+100M'],
        searchFormeJuridique: [],
        searchEtat: [],
        searchType: [],
        searchWilaya: [],
        searchNationalite: [],
        // searchAnnonceur: [],
        searchSecteur: []
        /* dateEcheance: {
          type: null,
          start: null,
          end: null
        } */
      })))
      delete state.searchEnFilter.nom
      delete state.searchEnFilter.checked
      delete state.searchEnFilter.id
      // do something
    }
    filter.checked = !filter.checked
  },
  UPDATE_ACTIVE_EN_FILTER: (state, filter) => {
    const cleanFilter = Object.assign({}, filter)
    delete cleanFilter.nom
    delete cleanFilter.checked
    delete cleanFilter.id
    state.activeEnFilter = Object.assign(state.activeEnFilter, cleanFilter)
  },
  UPDATE_SEARCH_EN_FILTER: (state, filter) => {
    state.searchEnFilter = Object.assign(state.searchEnFilter, filter)
  },
  DELETE_SAVED_EN_FILTER: (state, index) => {
    state.saveEnFilter.splice(index, 1)
  },
  SHOULD_CHECK_EN_FILTER: (state, index) => {
    state.saveEnFilter[index].checked = true
  },
  SHOULD_UNCHECK_EN_FILTER: (state, index) => {
    state.saveEnFilter[index].checked = false
  },
  SET_LIST_ENTREPRISE: (state, data) => {
    state.listeEntreprises = data.data
    state.listeEntreprisesPagination = {
      total: data.total,
      per_page: data.per_page,
      current_page: data.current_page,
      last_page: data.last_page,
      next_page_url: data.next_page_url,
      prev_page_url: data.prev_page_url,
      from: data.from,
      to: data.to
    }
  },
  SET_ENTREPRISE_PAGE: (state, data) => {
    state.listeEntreprisesPagination.current_page = data
  },
  SET_INIT_RECHERCHE_ENTREPRISE: (state, data) => {
    state.initRecherche = data
  }
}

const actions = {
  setLoadTableEntreprise (store, value) {
    store.commit('SET_LOAD_TABLE_ENTREPRISE', value)
  },
  setEnFilter (store, value) {
    store.commit('SET_EN_FILTER', value)
  },
  setSaveEnFilter (store, data) {
    store.commit('UNCHECK_ALL_EN_FILTERS')
    store.commit('SET_SAVE_EN_FILTER', JSON.parse(JSON.stringify(data)))
    // store.commit('CHECK_UNCHECK_EN_FILTER', data)
  },
  setDeleteEnFilter (store, data) {
    // swal('Bravo!', 'inscription success!', 'success')
    store.commit('SET_DELETE_EN_FILTER', data)
  },
  updateCheckedFilter (store, data) {
    store.commit('SET_UPDATE_CHECKED_EN_FILTER', data)
  },
  deleteCheckedEnFilter (store) {
    store.commit('SET_DELETE_CHECKED_EN_FILTER')
  },
  setButtonEnFilter (store, data) {
    store.commit('SET_BUTTON_EN_FILTER', data)
  },
  checkUncheckEnFilter (store, filter) {
    store.commit('CHECK_UNCHECK_EN_FILTER', filter)
  },
  updateActiveEnFilter (store, filter) {
    store.commit('UPDATE_ACTIVE_EN_FILTER', filter)
  },
  updateSearchEnFilter (store, filter) {
    store.commit('UPDATE_SEARCH_EN_FILTER', filter)
  },
  deleteSavedEnFilter (store, index) {
    if (state.saveEnFilter[index].checked) {
      store.commit('CHECK_UNCHECK_EN_FILTER', state.saveEnFilter[index])
    }
    store.commit('DELETE_SAVED_EN_FILTER', index)
  },
  shouldCheckEnFilter (store, index) {
    store.commit('SHOULD_CHECK_EN_FILTER', index)
  },
  shouldUncheckEnFilter (store, index) {
    store.commit('SHOULD_UNCHECK_EN_FILTER', index)
  },
  uncheckAllEnFilters (store) {
    store.commit('UNCHECK_ALL_EN_FILTERS')
  },
  setListEntreprise (store, data) {
    // swal('Bravo!', 'inscription success!', 'success')
    store.commit('SET_LIST_ENTREPRISE', data)
  },
  setEntreprisePage (store, data) {
    store.commit('SET_ENTREPRISE_PAGE', data)
  },
  setInitRechercheEntreprise (store, data) {
    store.commit('SET_INIT_RECHERCHE_ENTREPRISE', data)
  }
}

const getters = {
  showEnFilter: state => state.showEnFilter,
  saveEnFilter: state => state.saveEnFilter,
  checkedEnFilters: state => state.checkedEnFilters,
  activeEnFilter: state => state.activeEnFilter,
  addButtonEnFilter: state => state.addButtonEnFilter,
  searchEnFilter: state => state.searchEnFilter,
  listeEntreprises: state => state.listeEntreprises,
  listeEntreprisesPagination: state => state.listeEntreprisesPagination,
  chargementTableEntreprise: state => state.chargementTableEntreprise,
  initRecherche: state => state.initRecherche
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/components/store/modules/entreprise.js